import Button from "@mostrans/web-components/components/base/Button";
import Input from "@mostrans/web-components/components/base/Input";
import { Dialog, Paper } from "@mui/material";
import { Box } from "@mui/system";
import React, { useRef, useState } from "react";
import Cards from "../../../components/Card/Cards";
import Filter from "../../../components/Filter/Filter";
import Footer from "../../../components/Home/Footer";
import NavBar from "../../../components/Home/Navbar";
import { useGlobalFilter } from "../../../shared/hooks/useGlobalFilter";
import HomeCarousel from "./components/Carousel";

function Career() {
  // const [filter, setFilter] = useState();
  const { filter, setFilter } = useGlobalFilter();
  const [openFilter, setOpenFilter] = useState(false);

  const handleClose = () => {
    setOpenFilter(false);
  };

  const handleChange = (e) => {
    setFilter({ search: e.target.value.toLowerCase() });
  };

  // const { state } = useLocation();

  // useEffect(() => {
  //   if (state?.search) {
  //     setFilter({ search: state.search });
  //   }

  //   if (!state?.search || state?.pathname !== "/explorejobs") {
  //     resetFilter("search");
  //   }
  // }, [state.search, setFilter, resetFilter, state.pathname]);

  const exploreCareer = useRef(null);
  return (
    <React.Fragment>
      <NavBar />
      <Box mt={"80px"} className="bg-white">
        <HomeCarousel />
        <Paper
          className="form-search bg-white"
          variant="outlined"
          style={{ zIndex: 100 }}>
          <form className="search justify-content-center">
            <div className="button-filter">
              <Button
                variant="contained"
                color="inherit"
                onClick={() => {
                  setOpenFilter(true);
                  <Filter
                    open={openFilter}
                    handleClose={handleClose}
                    setOpen={setOpenFilter}
                  />;
                }}>
                <span className="material-icons"> tune </span>
              </Button>
            </div>
            <Input
              className="input-search"
              onChange={(e) => setFilter({ search: e.target.value })}
              value={filter.search}
              // type="text"
              placeholder="Business Development, Developer, Finance, etc"
            />
            <Button
              className="button-search"
              variant="contained"
              color="primary">
              Search Jobs
            </Button>
          </form>
        </Paper>
      </Box>
      <Box className="bg-neutral-n1" ref={exploreCareer}>
        <div
          className="opportunities bg-white container-fluid"
          style={{
            // marginTop: "10px",
            position: "flexible",
            height: "auto",
          }}>
          <div className="container-fluid">
            <div className="row" style={{ margin: "0" }}>
              <div className="col-lg-3 my-1">
                <div
                  className="filter-jobs"
                  style={{ justifyContent: "center" }}>
                  <Dialog
                    open={openFilter}
                    onClose={handleClose}
                    style={{ width: "auto", margin: "auto" }}>
                    <Filter
                      open={openFilter}
                      handleClose={handleClose}
                      setOpen={setOpenFilter}
                    />
                  </Dialog>
                  <Filter />
                </div>
              </div>
              <div className="col-lg-9">
                <Cards search={filter.search} />
              </div>
            </div>
          </div>
        </div>
      </Box>
      <Footer />
    </React.Fragment>
  );
}

export default Career;
